"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_MESSAGE = exports.LOGIN_STATUS = exports.ScreenType = void 0;
var ScreenType;
(function (ScreenType) {
    ScreenType["PHONE_INPUT_SCREEN"] = "phone_input_screen";
    ScreenType["OTP_INPUT_SCREEN"] = "otp_screen";
})(ScreenType || (exports.ScreenType = ScreenType = {}));
var LOGIN_STATUS;
(function (LOGIN_STATUS) {
    LOGIN_STATUS["SUCCESS"] = "login_success";
    LOGIN_STATUS["FAILURE"] = "login_failure";
    LOGIN_STATUS["PHONE_NUMBER_INCORRECT"] = "phone_number_incorrect";
})(LOGIN_STATUS || (exports.LOGIN_STATUS = LOGIN_STATUS = {}));
var IFRAME_MESSAGE;
(function (IFRAME_MESSAGE) {
    IFRAME_MESSAGE["EDIT_CLICKED"] = "edit_clicked";
    IFRAME_MESSAGE["HEIGHT_RESIZE"] = "height_resize";
})(IFRAME_MESSAGE || (exports.IFRAME_MESSAGE = IFRAME_MESSAGE = {}));
//# sourceMappingURL=interface.js.map